import { render, staticRenderFns } from "./collector-back-money.vue?vue&type=template&id=77521248&scoped=true"
import script from "./collector-back-money.vue?vue&type=script&lang=ts"
export * from "./collector-back-money.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77521248",
  null
  
)

export default component.exports